import { defineStore } from 'pinia';

import { ErrorObject, PersistingErrorState } from './types';

export const usePersistingErrorStore = defineStore('error', {
    state: (): PersistingErrorState => ({
        error: null,
    }),
    actions: {
        setError(error: ErrorObject | { message: string } | null) {
            this.error = error || null;
        },
        async showError(error: ErrorObject | Error | { message: string } | string | null) {
            this.setError(typeof error === 'string' ? { reason: error } : error || null);
        },
    },
});
